import * as React from "react";
import { Resizable } from "react-resizable";
import { resizableColumnsTableWrapper } from "./resizableTable";
class ResizableCell extends React.Component {
    constructor(props) {
        super(props);
        this.onResize = (index, _e, data) => {
            let { dataSource } = this.state;
            let { size } = data;
            let currentData = dataSource[index];
            if (currentData.width) {
                currentData.width = size.width;
            }
            if (currentData.height) {
                currentData.height = size.height;
            }
            dataSource[index] = currentData;
            this.setState({ dataSource }, () => {
                this.props.onChange && this.props.onChange(dataSource);
            });
        };
        this.state = {
            dataSource: props.dataSource ? props.dataSource : [],
            resize: this.props.resize ? [this.props.resize] : ['right']
        };
    }
    render() {
        let { dataSource, resize } = this.state;
        return (<div className="resizable-cell-main">
      {dataSource.map((element, index) => {
            return (<Resizable height={element.height} width={element.width} resizeHandles={resize} onResize={this.onResize.bind(this, index)} draggableOpts={{ enableUserSelectHack: false }}>
            <div style={{ width: element.width, height: element.height }}>
             {React.isValidElement(element.content) ? element.content : <span>{element.content}</span>}
            </div>
          </Resizable>);
        })}
    </div>);
    }
}
ResizableCell.resizableColumnsTableWrapper = resizableColumnsTableWrapper;
export default ResizableCell;



// WEBPACK FOOTER //
// ./components/resizablecell/index.tsx